// extracted by mini-css-extract-plugin
module.exports = {"box_container":"styles_box_container___Lot3","hide":"styles_hide__LXRL6"};